import { Download } from '@mui/icons-material';
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { get, isArray } from 'lodash';
import React, { FC } from 'react';
import { STRAPI_URL } from 'src/lib/constants/url';
import { GetFileSize } from 'src/utils/formats';

interface DownloadFileFromComponentProps {
	component: any;
	filePathInComponent: string;
	showDownloadButton?: boolean;
}

const DownloadFileFromComponent: FC<DownloadFileFromComponentProps> = ({ component, filePathInComponent, showDownloadButton = true }) => {
	const handleDownload = async (url: string, fileName: string) => {
		try {
			// Private file URLs need the /api/files prefix so the accessToken cookie (path: '/api') is sent
			const fileUrl = url.startsWith('/private/') ? `${STRAPI_URL}/api/files${url}` : `${STRAPI_URL}${url}`;
			let res = await fetch(fileUrl, {
				credentials: 'include',
			});

			const blob = await res.blob();
			const objectUrl = URL.createObjectURL(blob);

			const link = document.createElement('a');
			link.href = objectUrl;
			link.download = fileName;
			document.body.appendChild(link);
			link.click();
			link.remove();
			URL.revokeObjectURL(objectUrl);
		} catch (err: any) {
			console.error('ERROR: downloading File ', err);
		}
	};

	if (isArray(component) && component.length > 0) {
		return (
			<>
				<TableContainer sx={{ overflow: 'initial', mt: '1rem' }}>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell>Titel</TableCell>
								<TableCell align='right'>Dateigröße</TableCell>
								<TableCell align='right'>Aktion</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{component.map((ele: any, i: number) => {
								const fileMetaData = get(ele, filePathInComponent, {});
								return (
									<TableRow key={i}>
										<TableCell>{get(ele, 'Titel')}</TableCell>
										<TableCell align='right'>
											{GetFileSize(get(fileMetaData, 'attributes.size') / (get(fileMetaData, 'id') ? 1 : 1000))}
										</TableCell>
										<TableCell align='right'>
											{showDownloadButton && get(fileMetaData, 'attributes.url', '') && (
												<IconButton
													onClick={() => handleDownload(get(fileMetaData, 'attributes.url', ''), get(fileMetaData, 'attributes.name'))}
												>
													<Download />
												</IconButton>
											)}
										</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					</Table>
				</TableContainer>
			</>
		);
	}
	return <></>;
};
export default DownloadFileFromComponent;
